import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserLicence, UserLicenceAuthResponse } from 'app/shared/models/Users/user';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import * as sha512 from 'js-sha512';
import { OpendialogCreateUserFfvLicenceComponent } from '../opendialog-create-user-ffv-licence/opendialog-create-user-ffv-licence.component';

@Component({
  selector: 'app-login-ffv',
  templateUrl: './login-ffv.component.html',
  styleUrls: ['./login-ffv.component.scss']
})
export class LoginFfvComponent implements OnInit {

  @Input() loginFfv: boolean;
  @Output() newLoginFfv = new EventEmitter<boolean>();


  ffvLoginForm: FormGroup;
  inactive = false;
  loading = false;


  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private dataService: DataService,
    private dialog: MatDialog,
    private userService: UserService,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {
    const userLicence: UserLicence = {
      licence: this.ffvLoginForm.get('licence').value,
      password: sha512.sha512(this.ffvLoginForm.get('password').value)
    };

    this.authService.loginFFV(userLicence).subscribe({
      next: () => this.router.navigate(['/']),
      error: error => {
        error.error.error === 'unauthorized_client' ?
          this.openDialogCreateUserByFfvLicence(userLicence) :
          this.uiService.openSnackBar(error.error.error_description, '');
      },
      complete: () => this.dataService.isConnect.next(true)

    });
  }

  isInactive(inputValue: string): void {
    inputValue ? this.inactive = true : this.inactive = false;
  }

  back(): void {
    this.newLoginFfv.emit(false);
  }

  private openDialogCreateUserByFfvLicence(user: UserLicence): void {
    const dialofRef = this.dialog.open(OpendialogCreateUserFfvLicenceComponent, { data: { userFfv: user } });

    dialofRef.afterClosed().subscribe(res => {
      this.createUserByNLicence(res);
    });
  }



  private createUserByNLicence(user: UserLicenceAuthResponse): void {
    this.userService.createUserByNLicence(user).subscribe({
      next: () => { this.router.navigate(['/confirm-register']); },
    });
  }

  private initForm(): void {
    this.ffvLoginForm = this.formBuilder.group({
      licence: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

}
